import z from "zod";

const profileSchema = z.object({
    name: z.string(),
});
const profilesResponseSchema = z.array(profileSchema);

export async function getProfiles(audience: number, nullValue?: string) {
    const response = await fetch(
        `/srp/api/user-profiles/?audience=${audience}`,
    );
    const profiles = profilesResponseSchema.parse(await response.json());

    return [nullValue!, ...profiles]
        .filter((x) => Boolean(x))
        .map((p, i) => ({
            key: `profile-${i}`,
            label: typeof p === "string" ? p : p.name,
            value:
                typeof p === "string"
                    ? p
                    : p.name.toUpperCase().replace(/ /g, "_").replace(/,/g, ""),
        }));
}
